export const DEFAULT_NAV_NUMBER = 2824218369;

export let NAV_NUMBER = DEFAULT_NAV_NUMBER;

export function setNavNumber(value) {
  NAV_NUMBER = value;
}
